import { initializeIndexedDB } from "./lib";

export const DASHBOARD_INDEXEDDB_VERSION = 2;

/**
 * @description Dashboard IndexedDB in read mode (/projects/:projectId/dashboards/:dashboardId)
 */
export const defineDashboardIndexedDB = () =>
  initializeIndexedDB("dashboards", DASHBOARD_INDEXEDDB_VERSION, {
    dashboards: {
      parameters: { keyPath: "id" },
      indexes: {
        projectId: { keyPath: "projectId", parameters: { unique: false } },
      },
    },
    blocks: {
      parameters: { keyPath: "id" },
      indexes: {
        dashboardId: { keyPath: "dashboardId", parameters: { unique: false } },
      },
    },
  });

/**
 * @description Dashboard Editor IndexedDB in write
 * mode (/projects/:projectId/dashboards/:dashboardId/edit)
 * This is the source of content for the dashboard
 * editor to keep changes in cache without losing
 * existing content on save
 */
export const defineDashboardEditorIndexedDB = () =>
  initializeIndexedDB("dashboards/editor", DASHBOARD_INDEXEDDB_VERSION, {
    document: {
      parameters: { keyPath: "id" },
      indexes: {
        dashboardId: { keyPath: "dashboardId", parameters: { unique: false } },
      },
    },
  });

export type DashboardIndexedDBT = Awaited<ReturnType<typeof defineDashboardIndexedDB>>;
export type DashboardEditorIndexedDBT = Awaited<ReturnType<typeof defineDashboardEditorIndexedDB>>;
